<template>
    <div
        v-if="credit"
        class="credit"
    >
        {{ credit }}
    </div>
</template>

<script>
export default {
    props: {
        credit: String,
    },
}
</script>

<style>
.credit {
    @apply border px-4 py-3 uppercase text-sm lg:text-base;
    letter-spacing: 2px;
}
</style>
